module.exports = __webpack_public_path__ + "img/couples-058.c009d3fe.jpg";